function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h242v203H0z"
}), /*#__PURE__*/React.createElement("circle", {
  id: "d",
  cx: 197.5,
  cy: 118.5,
  r: 45.5
}), /*#__PURE__*/React.createElement("filter", {
  x: "-8.2%",
  y: "-8.2%",
  width: "116.5%",
  height: "116.5%",
  filterUnits: "objectBoundingBox",
  id: "c"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  id: "e",
  d: "M46 4.633L41.367 0 23 18.367 4.633 0 0 4.633 18.367 23 0 41.367 4.633 46 23 27.633 41.367 46 46 41.367 27.633 23z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M218.4 20.36c-6.437 19.026-21.578 34.058-40.693 40.373V20h40.815c-.036.123-.08.245-.122.36zm-194.8 0a5.277 5.277 0 0 1-.122-.36h40.815v40.733C45.178 54.418 30.037 39.386 23.6 20.36zM0 0a84.1 84.1 0 0 0 2.442 20c.021.122.057.244.086.36 7.571 30.2 31.453 53.95 61.765 61.368v.634c0 27.937 20.286 51.128 46.955 55.744v21.882h-5.108c-11.877 0-21.545 9.413-21.937 21.17-11.338.86-20.272 10.306-20.272 21.842h113.776c0-11.536-8.933-20.983-20.272-21.841-.392-11.758-10.06-21.171-21.936-21.171h-4.747v-21.882c26.669-4.616 46.955-27.807 46.955-55.744v-.634c30.312-7.419 54.194-31.167 61.765-61.368.029-.116.065-.238.086-.36A84.1 84.1 0 0 0 242 0H0z",
  fill: "#FED542",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#c)",
  xlinkHref: "#d"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#d"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(175 95)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#DD0D00",
  fillRule: "nonzero",
  xlinkHref: "#e"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#f)",
  fill: "#D0021B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h46v46H0z"
}))));

var SvgCupWrong = function SvgCupWrong(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 203,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCupWrong, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cup_wrong.268c4172.svg";
export { ForwardRef as ReactComponent };